import { Component, inject, OnInit, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { StatsComponent } from '../../components/stats/stats.component';
import { ChartComponent } from '../../components/chart/chart.component';
import { LastBudgetsComponent } from '../../components/last-budgets/last-budgets.component';
import { LastServicesComponent } from '../../components/last-services/last-services.component';
import { KanbanService } from '../../services/kanban.service';
import { CalendarService } from '../../services/calendar.service';
import { CardModule } from 'primeng/card';
import { BadgeModule } from 'primeng/badge';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { TagModule } from 'primeng/tag';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    StatsComponent,
    ChartComponent,
    LastBudgetsComponent,
    LastServicesComponent,
    CommonModule,
    RouterLink,
    CardModule,
    BadgeModule,
    ButtonModule,
    TooltipModule,
    TagModule
  ],
  templateUrl: './dashboard.component.html',
})
export class DashboardComponent implements OnInit {
  private readonly _headerService = inject(HeaderService);
  private readonly _kanbanService = inject(KanbanService);
  private readonly _calendarService = inject(CalendarService);

  username: string = '';
  currentDate: Date = new Date();

  // Computed stats from KanbanService
  kanbanStats = computed(() => {
    const cols = this._kanbanService.columns;
    const pending = cols.find(c => c.id === 'pending')?.tasks.length || 0;
    const inProcess = cols.find(c => c.id === 'in-process')?.tasks.length || 0;
    return { pending, inProcess };
  });

  highPriorityTasks = computed(() => {
    const allTasks = this._kanbanService.columns.flatMap(c => c.tasks);
    return allTasks
      .filter(t => t.attributes.priority === 'high' && t.attributes.status !== 'completed')
      .slice(0, 5); // Show top 5 high priority active tasks
  });

  upcomingEvents = computed(() => {
    const now = new Date();
    return this._calendarService.events()
      .filter(e => new Date(e.attributes.start) >= now || e.attributes.allDay)
      .sort((a, b) => new Date(a.attributes.start).getTime() - new Date(b.attributes.start).getTime())
      .slice(0, 4);
  });

  ngOnInit(): void {
    this._headerService.setHeader('', false);
    this.username = localStorage.getItem('username') || 'Usuario';
    this._calendarService.fetchEvents().subscribe();
  }

  getPrioritySeverity(priority: string): 'success' | 'info' | 'warning' | 'danger' | 'secondary' {
    switch (priority) {
      case 'high': return 'danger';
      case 'medium': return 'warning';
      case 'low': return 'info';
      default: return 'secondary';
    }
  }
}
